import { useEffect, useState } from "react";
import style from "./photos.module.scss";
import { AdditionalPhotos } from "./additionalPhotos";
import { useDispatch, useSelector } from "react-redux";
import { patientAssessmentHistoryAsync, setSelectedPhotosToCompare, setUploadAdditionalPhotos } from "../../../../app/patientSlice";
import { useParams } from "react-router-dom";
import { ComparePhotos } from "./comparePhotos";
import { UploadPhotos } from "./uploadPhotos";
import { CUSTOMER_UPDATE_SUCCESS, SUCCESS_STATUS } from "../../../../constants";

export const Photos = () => {
  const dispatch = useDispatch();
  const { patientId, assessmentId } = useParams();
  const [selectedRecordType, setSelectedRecordType] = useState("");
  const [selectedWoundImage, setSelectedWoundImage] = useState("");
  const [assessmentNumber, setAssessmentNumber] = useState("");
  const [comparePhotos, setComparePhotos] = useState(false);
  const [uploadPhotos, setUploadPhotos] = useState(false);
  const assessmentHistoryData = useSelector((state) => state.patient.assessmentHistory);
  const detailAssessment = useSelector((state) => state.patient.detailAssessment);
  const selectedPhotosToCompare = useSelector((state) => state.patient.selectedPhotosToCompare);
  const uploadAdditionalPhotos = useSelector((state) => state.patient.uploadAdditionalPhotos);
  const detailViewData = useSelector(state => state.patient.detailViewData);

  useEffect(() => {
    dispatch(patientAssessmentHistoryAsync(patientId, assessmentId));
    dispatch(setSelectedPhotosToCompare([]));
  }, [patientId, assessmentId, dispatch, detailAssessment?.reEvalSequence]);

  useEffect(() => {
    setTimeout(() => {
      dispatch(setUploadAdditionalPhotos(null));
    }, 5000);
  }, [dispatch, uploadAdditionalPhotos?.status]);

  useEffect(() => {
    const assessments = assessmentHistoryData?.followuphistory?.[0]?.assessments;

    if (assessments && assessments?.length > 0 && detailAssessment?.reEvalSequence > 0) {
      const firstAssessment = assessments[0];
      setSelectedRecordType(firstAssessment?.recordType);
      setSelectedWoundImage(firstAssessment?.picture);
      setAssessmentNumber(firstAssessment?.id);
    } else {
      setSelectedRecordType("Initial Assessment");
      setSelectedWoundImage(detailAssessment?.picture);
      setAssessmentNumber(detailAssessment?.id);
    }
  }, [assessmentHistoryData, detailAssessment]);

  const handleRecordTypeChange = (recordType, picture, id) => {
    setSelectedRecordType(recordType);
    setSelectedWoundImage(picture);
    setAssessmentNumber(id);
  };

  const handleComparePhotos = () => setComparePhotos(true);

  return (
    <>
      {comparePhotos ? (
        <ComparePhotos setComparePhotos={setComparePhotos} />
      ) : (
        <div className="row">
          <div className={`col-md-2 bg-light w-100 vh-100 ${style.primary_photo}`}>
            <ul className={`list-group mt-2`}>
              {(assessmentHistoryData?.followuphistory?.[0]?.assessments?.length > 0
                ? assessmentHistoryData.followuphistory[0].assessments
                : [detailAssessment]
              ).map(({ recordType, picture, id }) => {
                const safeRecordType = recordType || "Initial Assessment";
                return (
                  <li
                    key={safeRecordType}
                    className={`list-group-item shadow-lg ${safeRecordType === selectedRecordType ? `active ${style.selected}` : ""}`}
                    onClick={() => handleRecordTypeChange(safeRecordType, picture, id)}
                  >
                    <div className="d-flex justify-content-between">
                      <span>{safeRecordType}</span>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className={`col col-md-10 px-3`}>
            <div className="d-flex justify-content-between">
              {uploadAdditionalPhotos?.status === SUCCESS_STATUS ? <div className="d-inline alert alert-success">{CUSTOMER_UPDATE_SUCCESS}</div>: <div></div>}
              <div className="d-flex flex-wrap justify-content-end mb-4 mt-2">
                {detailViewData?.hasSecondoryPhotos !== 0 && <button
                  className={`btn mx-2 mb-2 ${style.icon_btns}`}
                  aria-label="Upload photos"
                  title="Upload Photos"
                  onClick={() => setUploadPhotos(true)}
                >
                  <i className="fa fa-cloud-upload" aria-hidden="true"></i>
                </button>}
                {/* <button className={`mx-2 mb-2 ${style.icon_btns}`} aria-label="Download photos" title="Download Photos">
                  <i className="fa fa-download" aria-hidden="true"></i>
                </button> */}
                {selectedPhotosToCompare?.length > 1 && (
                  <button onClick={handleComparePhotos} className={`btn mx-2 mb-2 ${style.icon_btns}`} aria-label="Compare photos" title="Compare Photos">
                    <i className="fa fa-exchange" aria-hidden="true"></i>
                  </button>
                )}
              </div>
            </div>
            <AdditionalPhotos primaryImage={selectedWoundImage} assessmentNumber={assessmentNumber} />
          </div>
        </div>
      )}
      {uploadPhotos && <UploadPhotos show={uploadPhotos} onClose={() => setUploadPhotos(false)} assessmentNumber={assessmentNumber} />}
    </>
  );
};
